import '../Project/projectgallery.css';
import { useEffect, useRef } from 'react';
import ArtofLiving from '../../images/Project_Images/artofliving_2.webp';
import KIMA from '../../images/Project_Images/KIMA_1.webp';
import IAS from '../../images/Project_Images/IAS_1.webp';
import hDfc from '../../images/Project_Images/hdfc.webp';
import GCIT from '../../images/Project_Images/gcit.webp';
import reccaClub from '../../images/Project_Images/reca_club_1.webp';
import SernityHall from '../../images/Project_Images/SBH-3.webp';
import GdMuseum from '../../images/Project_Images/GdMuseum3.webp';
import Fiorano from '../../images/Project_Images/fiorano_2.webp';

const projectData = [
    {
        id: 52,
        title: 'Fiorano Software Technologies',
        scope: 'We supplied and applied - FABRISORB – CLOUDS - FABRISORB – WALL PANELS - D\'ECOPANEL – CELL CEILING CLOUD - D\'ECOPANEL – SCREEN - D\'ECOPANEL – PRINTED PANELS - POLYMAX to transform their workspace into a sound - optimized environment tailored for productivity, collaboration, and visual appeal.',
        image: [Fiorano],
    },
    {
        id: 46,
        title: 'GD Museum - Experimenta Science Centre',
        scope: 'In this project, we conducted a testing and supplied Polysorb acoustic clouds, designed in hexagon and triangle shapes and in three distinct colors. By integrating Polysorb clouds, we delivered aesthetic yet functional acoustic solutions that complemented the museum’s innovative and experiential environment, fostering an engaging atmosphere for visitors.',
        image: [GdMuseum],
    },
    {
        id: 45,
        title: 'Serenity Banquet Hall',
        scope: 'For this project, we supplied and installed Echo Eliminator panels and Decopanel baffles in the ceiling area. These high-performance baffles meticulously designed in a wavy shape contributed to sound management within the banquet hall, ensuring an elegant ambiance while complementing the venue’s refined architectural design.',
        image: [SernityHall],
    },
    {
        id: 42,
        title: 'The Art of Living International Center',
        scope: 'We designed and built a state-of-the-art home theater within Gurudev’s Secretariat, ensuring an immersive audiovisual experience. Our expertise in acoustic design and precision engineering has created a space that delivers unparalleled sound quality and visual excellence, redefining luxury in home entertainment.',
        image: [ArtofLiving],
    },
    {
        id: 41,
        title: 'Kings International Medical Academy (KIMA)- Auditorium',
        scope: 'Our scope for this project involves the supply of Fabrisorb panels. These panels are designed to optimize the acoustic environment within the auditorium, ensuring that the spaces are conducive to clear and effective communication.',
        image: [KIMA],
    },
    {
        id: 40,
        title: 'IAS Officers Club, AP',
        scope: 'Our project scope included the supply and installation of Fabriwall and WoodTec systems. Our skilled team carried out the project with precision and creativity, turning the club into an ideal venue for various functions and gatherings.',
        image: [IAS],
    },
    {
        id: 33,
        title: 'HDFC Project',
        scope: 'Our well-trained technicians transformed the HDFC auditorium into an acoustic wonderland with FabriWall excellence. The before-and-after images speak volumes—where once there was monotony, now there’s vibrancy.',
        image: [hDfc]
    },
    {
        id: 32,
        title: 'GCIT College Auditorium',
        scope: 'Supply and installation of Polysorb Wall Panels and Clouds. Our skilled technicians, armed with their creativity, transformed and ensured the auditorium that once echoed into a space of harmony and acoustically optimized environment.',
        image: [GCIT],
    },
    {
        id: 30,
        title: 'Recca Club',
        scope: 'We supplied an exclusive range of Decopanel printed and plain series, along with Decowood panels. These high-quality elements was carefully selected to elevate the aesthetic appeal and functionality of Recca Club’s interiors and also to ensure it remains a premier destination for the members.',
        image: [reccaClub]
    },
];
function IconicProjects({ onProjectClick }) {
    const scrollRef = useRef(null);

    useEffect(() => {
        const scrollContainer = scrollRef.current;
        const onWheel = (e) => {
            e.preventDefault();
            scrollContainer.scrollLeft += e.deltaY;
        };
        scrollContainer.addEventListener('wheel', onWheel);

        return () => {
            scrollContainer.removeEventListener('wheel', onWheel);
        };
    }, []);

    return (
        <>
            <div className="container-fluid mb-5 mt-4">
                <div className='row'>
                    <div className="iconic-heading col-2">
                        <button type="button" className='btn'><p className='mb-4'>Our</p>
                            {'ICONIC PROJECTS'.split('').map((char, idx) => (
                                <span key={idx}>{char === ' ' ? '\u00A0' : char}</span>
                            ))}</button>
                    </div>
                    <div className="outterContainer col-10">
                        <div className="container-scroll" ref={scrollRef}>
                            {projectData.map(project => (
                                <div key={project.id}
                                    className="project-card"
                                    onClick={() => onProjectClick(project.id)}
                                    style={{ cursor: "pointer" }}>
                                        
                                    <img src={project.image} alt={project.title} className="project-image" />
                                    <div className="project-caption">
                                        <div className="project-title"><span className="project-id">{project.id}. </span>{project.title}</div>
                                        <div className="project-scope">{project.scope}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default IconicProjects